import { TonConnectUIProvider } from '@tonconnect/ui-react'
import '@ton/crypto'
import telegramAnalytics from '@telegram-apps/analytics'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import { useAppI18n, useTelegramSdk } from './hooks'
import { FirebaseProvider } from './hooks/useAnal'
import { userSettingsAtom } from './store/atoms'

export const TelegramMiniAppProvider = (props: {
  children: React.ReactNode
}) => {
  const userSettings = useAtomValue(userSettingsAtom)

  const i18nInstance = useAppI18n(userSettings.langCode || 'en')
  const { isLoaded, isForbidden } = useTelegramSdk()

  // TODO: add token (api key?)
  // useEffect(() => {
  //   void telegramAnalytics.init({
  //     token: 'YOUR_TOKEN',
  //     appName: 'Poker1337',
  //   })
  // }, [])

  if (isForbidden) {
    return <p>Forbidden</p>
  }

  if (!isLoaded || !i18nInstance) {
    return <p style={{ color: 'white' }}>Loading...</p>
  }

  return (
    <FirebaseProvider>
      <I18nextProvider i18n={i18nInstance}>
        <TonConnectUIProvider
          manifestUrl={import.meta.env.VITE_TON_MANIFEST_URL}
          actionsConfiguration={{
            twaReturnUrl: import.meta.env.VITE_TELEGRAM_APP_URL,
          }}
        >
          {props.children}
        </TonConnectUIProvider>
      </I18nextProvider>
    </FirebaseProvider>
  )
}
